interface Number
{
    isOdd(): boolean;
    toTimeString(format?: string): string;
    padLeft(width: number, filler?: string): string
}

if (typeof Number.prototype.isOdd !== 'function')
{
    Number.prototype.isOdd = function ()
    {
        return (this % 2) == 1;
    };
}

if (typeof Number.prototype.toTimeString !== 'function')
{
    Number.prototype.toTimeString = function (format?: string)
    {
        var sec_num = parseInt(this, 10); // don't forget the second param
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);

        if (hours < 10) { hours = 0 + hours; }
        if (minutes < 10) { minutes = 0 + minutes; }
        if (seconds < 10) { seconds = 0 + seconds; }

        switch (format)
        {
            case "hh":
                return hours.toString();
            case "hh:mm":
                return hours + ':' + minutes;
            default:
                return hours + ':' + minutes + ':' + seconds;
        }
    };
}

if (typeof Number.prototype.padLeft !== 'function')
{
    Number.prototype.padLeft = function (width: number, filler?: string)
    {
        filler = filler || "0";
        var value: string = parseInt(this).toString() + "";
        return value.length >= width ? value : new Array(width - value.length + 1).join(filler) + value;
    };
}